import {Autocomplete, Box, createFilterOptions, TextField} from "@mui/material";
import React from "react";
import {MachineApiGet, useGetMachineQuery} from "./machine_api";
import {MultiSearchProps} from "../../components/SearchBox";
import {Tables} from "../../apitypes";
import AvatarImage from "../storage/AvatarImage";


export default ({onChange, value}: MultiSearchProps<Tables<"machine">>) => {

    const {data} = useGetMachineQuery({});

    return <Autocomplete
        id={"MachineApiGet"}
        multiple
        options={data || []}
        autoHighlight
        sx={{minWidth: "200px"}}
        value={value}
        onChange={(e, v: MachineApiGet[]) => onChange(v)}
        getOptionLabel={(option: MachineApiGet) => {
            return option.Code;
        }}
        filterOptions={createFilterOptions({
            stringify: (option) => option.Code + " " + option.Name,
        })}
        renderOption={(props, option: MachineApiGet) => {
            return <Box component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} {...props}>
                <AvatarImage image_url={option.image_url} bucket={"machines"}/>  {option.Name} ({option.Code})
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}

                label="Stroj"
                variant={"standard"}

            />
        )}
    />
}
